<template>
  <component 
    :is="floor.$style" 
    :floor="floor" 
    :home="home" 
    @call="e => $emit('call', e)"
    @jump="onJumpToGoodsDetail"
  />
</template>

<script>
import { navigateTo } from '@/views/activities/utils'
import StyleOne from './style-one'
import StyleTwo from './style-two'
import StyleThree from './style-three'
export default {
  components: { StyleOne, StyleTwo, StyleThree },
  props: {
    floor: Object,
    home: Object
  },
  created() {
    this.uploadGio()
  },
  methods: {
    onJumpToGoodsDetail({ item, index }) {
      this.uploadClickGio(item, index)
      navigateTo(this, {
        pageLinkType: 3,
        pageLinkValue: item.goodsId
      })
    },
    uploadClickGio(item, index) {
      gio('track','flowLocationClick',{
        'indexId_var': this.home.contentPageId,
        'entryType_vara': '限时秒杀',
        'entryType_floor_var': this.floor.$index,
        'position_var': index,
        'sort_var': '',
        'positionName_var': item.goodsName
      })
      gio('setEvar', 'module_evar', '限时秒杀')
    },
    uploadGio() {
      const { home, floor } = this;

      //ver607  首页曝光
      if(home&&home.$from =="home"){
        gio('track','moduleExposure',{
          pageType_var: home.$pageName,
          indexId_var: home.contentPageId,
          entryType_vara: '限时秒杀',
          entryType_floor_var: floor.$index,
        })
      }

    },
    onCall(e) {
      this.triggerEvent('call', e.detail)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
